import { z } from "zod";

export const reportQuestionnaireSchema = z.object({
  id: z.coerce.string(),
  name: z.string(),
});

export type ReportQuestionnaire = z.infer<typeof reportQuestionnaireSchema>;

export const reportMunicipalitySchema = z.object({
  id: z.number(),
  name: z.string(),
  regionName: z.string().nullable(),
});

export type ReportMunicipality = z.infer<typeof reportMunicipalitySchema>;

export const reportMonthSchema = z.string().regex(/^\d{4}-\d{2}$/);
